import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Alerts from '../../../../prototypes/Alerts';
import { clearUserProfile } from '../../../../redux/actions/user';
import { clearBugsnagUser } from '../../../../redux/actions/bugsnag';
import EtelAPI from '../../../../api/EtelAPI';
import { Dialog, DialogHeader, DialogBody, DialogFooter } from '../../../../presentation/Dialog';
import Overlay from '../../../../presentation/Overlay';
import LoadingDialog from './LoadingDialog';
import DeleteDialog from './DeleteDialog';
import UploadDropZone from './UploadDropZone';

import * as wj from 'wijmo/wijmo.react.grid';
import * as wijmo from 'wijmo/wijmo';

// Wijmo Key
wijmo.setLicenseKey(
  'stage.etelconnections.com|172.16.0.116|dev.etelconnections.com|172.16.2.189|stage.eteconnections.com|172.16.1.15|www.etelconnections.com|172.16.0.112|lv.etelconnections.com|etelconnections.com|www.dev.etelconnections.com|172.16.1.22,854482378799655#B032Sbj9ycu3Wa4NWZu96bjxWZ4VmLldWY4NnI0IyctRkIsIybjVGblRVLFJiOiEmTDJCLiUTN6kTO7gzNzIDO4QTN8IiOiQWSiwSfdtlOicGbmJCLiIjdyIDMyIiOiIXZ6JCLlNHbhZmOiI7ckJye0ICbuFkI1pjIEJCLi4TPBh7RwYjWClUQRFnby9UMrYUcIJEZa5EevlTSzJHepVjdqxEZsl7QxhUS4t6UyFEdPNGbClWMQJHc7Z4Kv2EcG5kQwVzdMd4dIpHMrwWcz8ESONUW4wUQ7tCSBhmMIhzcykGTMpmTlNXMvpXRrd5Qo3ES7NUcPtSM9YHMMBVRJ36MtxUTxx6cBdlM64mUIZDMOdGWYhGZC3EcHdkRSZjZFBFUZ5GZX9ET8tSTMNVe5R7dzhlaYFUc5YVOadUe6ZjZWVDULt4RNBndYJ7U4NTbwckRItUUsF7c42Wc94WVEh7Y4JzRQRmMnJ5QrAnaThWdygVSqdkZaBFRrlHVP3UcrYENzRTOVR5bRJXQ6xka8ZnTqdlcitEcxtWZzhFSqZXaZJkeG3yKFZkSCpkR6QnexYjb43SWH9UbChXRykGTkxETn5UVrlzavIlR0lFNuNkbtZEdIJDSiojITJCLikTO6czN6IUNiojIIJCLwEjM6gDM4gTO0IicfJye35XX3JSSwIjUiojIDJCLi86bpNnblRHeFBCI4VWZoNFelxmRg2Wbql6ViojIOJyes4nI5kkTRJiOiMkIsIibvl6cuVGd8VEIgIXZ7VWaWRncvBXZSBybtpWaXJiOi8kI1xSfis4N8gkI0IyQiwiIu3Waz9WZ4hXRgAydvJVa4xWdNBybtpWaXJiOi8kI1xSfiQjR6QkI0IyQiwiIu3Waz9WZ4hXRgACUBx4TgAybtpWaXJiOi8kI1xSfiMzQwIkI0IyQiwiIlJ7bDBybtpWaXJiOi8kI1xSfiUFO7EkI0IyQiwiIu3Waz9WZ4hXRgACdyFGaDxWYpNmbh9WaGBybtpWaXJiOi8kI1tlOiQmcQJCLiAzMwEDOwAyNxgDMzIDMyIiOiQncDJCLiIjMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL6VGZuc7d7xSbvNmLz96bpR7Yl9mbvNGblRXZs46bj9ycu3Wa4NWZu96bjxWZ4VmL6xGLyETMuAjL6EjLycTMs46bj9ycu3Wa4NWZu96bjxWZ4VmL7d7dsUTMuEjL6EjLycTMs46bj9ycu3Wa4NWZu96bjVGdl9SZnFGdzxSO8EjLy8iNx8iM7EDLt36YuMnbvlGdjVmbu36YsVGdl9idlRGL6ETMuAjL6EjLtcYM'
);

class FileDetailsByDNISDialog extends Component {
  constructor( props ) {
    super( props );

    this.state = {
      show: props.show === undefined ? false : props.show,
      contents: [{ NUMBER: 'Loading' }],
      details: [{ PROCESSED_ON: 'Loading' }],
      acceptedFiles: [],
      allowedUploadTypes: [],
      programTypes: [],
      defaultPrograms: [],
      descriptions: {},
      itemToRemove: {},
      actionStatus: {
        current: 0,
        total: 0
      },
      uploadType: '',
      programType: '',
      DEFDNIS: '',
      DEST_ID: '',
      applyingDialogBody: '',
      deleteBody: '',
      loading: true,
      showLoadingApplyingDialog: false,
      showDeleteDialog: false
    };

    // Bindable events
    this.onHandleException = this.onHandleException.bind( this );
    this.onHandleChange = this.onHandleChange.bind( this );
    this.onHandleAddFile = this.onHandleAddFile.bind( this );
    this.onHandleClickRemoveFile = this.onHandleClickRemoveFile.bind( this );
    this.onHandleClickApply = this.onHandleClickApply.bind( this );
    this.onHandleClickDelete = this.onHandleClickDelete.bind( this );
    this.onHandleOpenDeleteDialog = this.onHandleOpenDeleteDialog.bind( this );
    this.onHandleClose = this.onHandleClose.bind( this );
    this.onHandleCloseDialogs = this.onHandleCloseDialogs.bind( this );

    // Build the delete icon
    this.formatCell = this.formatCell.bind( this );

    // Properties / fields
    this.wijmoGrid1 = React.createRef(); // Contents
    this.wijmoPanel1 = null;
    this.wijmoGrid2 = React.createRef(); // Details
    this.wijmoPanel2 = null;

    this.buttonEvents = []; // Event for the delete icon
  }

  /****************************************************************************
   * STATE / LIFECYCLE METHODS
   ***************************************************************************/

  componentDidMount() {
    this.alerts = new Alerts( this.props.bugsnag, this.props.dispatch );
  }

  componentWillReceiveProps( nextProps ) {
    if ( this.props.show !== nextProps.show ) {
      this.setState( {
        show: nextProps.show === undefined ? false : nextProps.show
      }, () => {
        if ( this.state.show ) {
          const fileUploadContentsParams = [
            { FILE_UPLOAD_ID: this.props.filedata.FILE_UPLOAD_ID },
            { START: 1 },
            { END: 1000 }
          ];

          const fileUploadSearchParams = [
            { FILE_UPLOAD_ID: this.props.filedata.FILE_UPLOAD_ID }
          ];

          Promise.all( [
            this.getFileUploadContents( fileUploadContentsParams ),
            this.fileUploadSearch( fileUploadSearchParams ),
            this.programListsUtility( [{ COLUMN_NAME: 'ROUTING_TYPE_ID' }] ),
            this.programListsUtility( [{ COLUMN_NAME: 'PDNIS' }] )
          ] ).then( ( [fileUploadContentsResults, fileUploadSearchResults,
            programTypesResults, defaultProgramsResults] ) => {

            for ( let fileUploadResult of fileUploadSearchResults ) {
              fileUploadResult['__delete__button'] = true;
            }

            this.setState( {
              contents: fileUploadContentsResults,
              details: fileUploadSearchResults,
              allowedUploadTypes: this.props.filedata.ALLOWED_TYPES.split( ', ' ),
              programTypes: programTypesResults,
              defaultPrograms: defaultProgramsResults,
              DEST_ID: this.props.filedata.DEST_ID,
              loading: false
            } );
          } ).catch( ( exception ) => {
            this.onHandleException( exception );
          } );
        }
      } );
    }
  }

  /****************************************************************************
   * API CALLS
   ***************************************************************************/

  /**
   * Retrieves the file contents.
   *
   * @param {Array<Object>} params Parameters to be used for the search.
   */
  getFileUploadContents( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/bydnis/contents' );

      api.get( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Retrieves the files by DNIS.
   *
   * @param {Array<Object>} params Parameters to pass to the endpoint.
   */
  fileUploadSearch( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/fileuploadsearch' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Gets the progress for this file when applying to a DNIS.
   *
   * @param {Array<Object>} params Parameters to be used for the search.
   */
  getProgress( params ) {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/progress' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Gets the routing types for the dropdowns. Also gets all programs.
   */
  programListsUtility( params ) {
    return new Promise( ( resolve, reject ) => {
      let api = new EtelAPI( 'filemanagement/byfilename/programlistsutility' );

      if ( api !== undefined ) {
        api.get( params ).then( ( results ) => {
          resolve( results );
        } ).catch( ( exception ) => {
          reject( exception );
        } );
      }
    } );
  }

  /**
   * Inserts into the table FL_FILE.
   *
   * @param {Object} params Parameters to be used for the insert.
   */
  fl_file_insert( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/flfileinsert' );

      api.insert( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Inserts into the table FL_FILE_CONTENTS.
   *
   * @param {Object} params Parameters to be used for the insert.
   */
  fl_file_contents_insert( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/flfilecontentsinsert' );

      api.insert( params ).then( ( results ) => {
        if ( this.state.actionStatus.current < this.state.actionStatus.total ) {
          const updatedActionStatus = { ...this.state.actionStatus };
          updatedActionStatus.current += 1;

          this.setState( {
            actionStatus: updatedActionStatus
          } );
        }

        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Inserts into the table FILE_UPLOAD and runs other jobs/background
   * processes.
   *
   * @param {Object} params Parameters used for the insert.
   */
  file_upload_insert( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/fileuploadinsert' );

      api.insert( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /**
   * Deletes the file from the DNIS.
   *
   * @param {int} params FILE_UPLOAD_ID to delete.
   */
  delete_from_dnis( params ) {
    return new Promise( ( resolve, reject ) => {
      const api = new EtelAPI( 'filemanagement/byfilename/deletefromdnis' );

      api.delete( params ).then( ( results ) => {
        resolve( results );
      } ).catch( ( exception ) => {
        reject( exception );
      } );
    } );
  }

  /****************************************************************************
   * EXCEPTION HANDLING
   ***************************************************************************/

  /**
   * Returns user back to the login page if creds fail.
   */
  doLogOff() {
    const { dispatch, auth, history } = this.props;

    auth.logout();
    dispatch( clearBugsnagUser() );
    dispatch( clearUserProfile() );
    history.push( '/login' );
  }

  /**
   * Handles exceptions.
   *
   * @param {Error} e The exception thrown.
   */
  onHandleException( e ) {
    const title = 'File Management';
    const status = e.status === undefined ? 0 : e.status;

    if ( status === 410 ) {
      this.alerts.INFO( title, 'Your session has expired.', 5000 );
      this.doLogOff();
    } else if ( status === 500 ) {
      this.alerts.INFO( title, e.statusText, 5000 );
      this.doLogOff();
    } else if ( status === 400 ) {
      this.alerts.WARNING( title, 'Request timed out.', 5000 );
    } else {
      this.alerts.CRITICAL( title, e );
    }
  }

  /****************************************************************************
   * HELPER METHODS
   ***************************************************************************/

  /**
  * Creates the delete button for each row.
  */
  formatCell( panel, r, c, cell ) {
    if ( panel.cellType === 1 ) { // 0 For None, 1 For Cell, 2 for ColumnHeader, 3 for RowHeader
      const col = panel.columns[c];

      // Delete button
      if ( col.binding === '__delete__button' ) {
        const copy_value = panel.getCellData( r, '__delete__button', false );
        if ( copy_value === true ) {
          let id = 'copy_cell_id_' + r.toString() + '_' + c.toString() + '_' + col.index;

          // Altering the cells inner html
          cell.innerHTML = '<div style="display:flex; align-items:center; justify-content: center;width:100%;height:100%;" id="' + id +
            '"><i class="icon-ikons-bin" style="color:#BE000E;font-size:14pt;cursor:pointer;display:flex; align-items:center; justify-content: center;width:100%;height:100%;"/></div>';

          // Create the button press listener
          let buttonCell = document.getElementById( id );
          if ( buttonCell !== undefined ) {

            // Adding the wijmo event to the object, so it can be removed on unmounting
            let copy_listener = new wijmo.Control( buttonCell );
            copy_listener.addEventListener( buttonCell, 'click', this.onHandleOpenDeleteDialog );
            this.buttonEvents.push( copy_listener );
          }
        } else {
          cell.innerHTML = '<div></div>';
        }
      }
    }
  }

  /**
   * Uploads the file and applies it to the DNIS.
   */
  uploadFilesToDNIS( file ) {
    const reader = new FileReader();

    reader.readAsText( file );
    reader.onabort = () => {
      this.alerts.CRITICAL( 'File upload', 'Reading was aborted.', false );
    };
    reader.onerror = () => {
      this.alerts.CRITICAL( 'File upload', 'Error during reading the file.', false );
    };
    reader.onload = () => { };

    reader.onloadend = () => {
      const numbers = [
        ...new Set(
          reader.result.trim().split( '\n' ).map( number => number.trim() )
        )
      ];
      const FL_FILE = {
        FILENAME: file.name,
        DESCRIPTION: this.state.descriptions['description-' + file.name],
        COUNT_TOTAL: numbers.length,
        USES: numbers.some( ( number ) => {
          return number.length >= 10;
        } ) ? 'OFF NET, ON NET, TFN' : 'OFF NET, ON NET',
        CREATEONDATE: new Date()
      };

      const updatedActionStatus = { ...this.state.actionStatus };
      updatedActionStatus.current = 1;
      updatedActionStatus.total += Math.ceil( FL_FILE.COUNT_TOTAL / 700 );

      this.setState( {
        showLoadingApplyingDialog: true,
        actionStatus: updatedActionStatus
      } );

      // Insert the file
      this.fl_file_insert( FL_FILE ).then( ( fl_file_results ) => {
        const promises = [];

        while ( numbers.length > 0 ) {
          const batch = numbers.splice( 0, 700 ).join( ',' );
          const batchParams = {
            FL_FILE_ID: fl_file_results.data[0].FL_FILE_ID,
            NUMBERS: batch,
            FILENAME: fl_file_results.data[0].FILENAME
          };

          promises.push( this.fl_file_contents_insert( batchParams ) );
        }

        // Insert all of the file's contents
        Promise.all( promises ).then( ( fl_file_contents_results ) => {
          const { filedata } = this.props;

          const file_upload_params = {
            FL_FILE_ID: fl_file_contents_results[0].data[0].FL_FILE_ID,
            DEFDNIS: this.state.DEFDNIS === '' ? this.state.DEST_ID : this.state.DEFDNIS,
            DEST_ID: this.state.DEST_ID,
            UPLOAD_TYPE: this.state.uploadType === 'TFN' ? 0 : this.state.uploadType === 'OFF NET' ? 1 : 2,
            FILENAME: file.name,
            DESCRIPTION: this.state.descriptions['description-' + file.name],
            COUNT_TOTAL: fl_file_contents_results[0].data[0].COUNT_TOTAL,
            DESTINATION: filedata.DESTINATION === 'LEADGEN' ? 1 : 2,
          };

          // Finally, apply the file to the DNIS
          this.file_upload_insert( file_upload_params ).then( ( file_upload_results ) => {
            const progressParams = [
              { FL_FILE_ID: fl_file_contents_results[0].data[0].FL_FILE_ID }
            ];

            this.checkApplyProgress( progressParams );

          } ).catch( ( file_upload_exception ) => {

            if ( file_upload_exception.statusText ) {
              this.alerts.CRITICAL( 'File Upload', file_upload_exception.statusText, false );
            } else {
              this.onHandleException( file_upload_exception );
            }

          } );

        } ).catch( ( fl_file_contents_exception ) => {

          if ( fl_file_contents_exception.statusText ) {
            this.alerts.CRITICAL( 'File Contents Upload', fl_file_contents_exception.statusText, false );
          } else {
            this.onHandleException( fl_file_contents_exception );
          }

        } );

      } ).catch( ( fl_file_exception ) => {

        if ( fl_file_exception.statusText ) {
          this.alerts.CRITICAL( 'File Upload', fl_file_exception.statusText, false );
        } else {
          this.onHandleException( fl_file_exception );
        }

      } );
    };
  }

  /**
   * Checks the progress of applying the file to a DNIS.
   *
   * @param {Array<Object>} progressParams Parameters to check the progress.
   */
  checkApplyProgress( progressParams ) {
    let time = 1;

    this.progressInterval = setInterval( () => {
      this.getProgress( progressParams ).then( ( results ) => {
        let progress = results[0].PROGRESS;

        if ( progress === null || progress === undefined || progress === '' ) {
          this.setState( {
            applyingDialogBody: 'Processing...'
          } );
        } else {
          this.setState( {
            applyingDialogBody: progress
          } );

          if ( progress === 'Complete' ) {
            clearInterval( this.progressInterval );

            this.setState( {
              applyingDialogBody: 'Refreshing...'
            } );

            // Wait 2 seconds for data to actually be written
            setTimeout( () => {
              this.onHandleClose( null, true );
            }, 2000 );
          }
        }

        // Failsafe to stop the interval if the progress never reached 'Complete'
        ++time;
        if ( time === 90 ) {
          clearInterval( this.progressInterval );
        }
      } ).catch( ( exception ) => {
        clearInterval( this.progressInterval );
        this.onHandleException( exception );
      } );
    }, 1000 );
  }

  /****************************************************************************
   * EVENT HANDLING
   ***************************************************************************/

  /**
   * Generic change event to handle the state updates for inputs/selects/etc.
   *
   * @param {Event} event Change event for an input/select/etc.
   */
  onHandleChange( event ) {
    if ( event.target.name.includes( 'description' ) ) {
      const newDescriptions = { ...this.state.descriptions };

      newDescriptions[event.target.name] = event.target.value;

      this.setState( {
        descriptions: newDescriptions
      } );
    } else {
      const name = event.target.name;

      this.setState( {
        [event.target.name]: event.target.value
      }, () => {
        if ( name === 'programType' ) {
          this.programListsUtility( [{ COLUMN_NAME: 'PDNIS' }, { ROUTING_TYPE_ID: this.state.programType }] ).then( ( results ) => {
            this.setState( {
              defaultPrograms: results
            } );
          } ).catch( ( exception ) => {
            this.onHandleException( exception );
          } );
        }

        if ( this.state.uploadType !== 'ON NET' ) {
          this.setState( {
            programType: '',
            DEFDNIS: ''
          } );
        }
      } );
    }
  }

  /**
  * Event of files being added into the DropZone.
  *
  * @param {Array<File>} files The files added into the DropZone.
  */
  onHandleAddFile( files ) {
    /**
     * Verifies if the file is valid -- Only numbers.
     *
     * Numbers will be turned into a set (no duplicates).
     *
     * @param {File} file The file to validate.
     */
    const verifyFiles = ( file ) => {
      const reader = new FileReader();

      reader.readAsText( file );
      reader.onload = () => {
        let content = reader.result.replace( /\s/g, '' );
        let contentArr = reader.result.trim().split( '\n' ).map( number => number.trim() );
        let contentSetLength = new Set( contentArr ).size;
        const tfn = contentArr.some( ( content ) => {
          return content.length >= 10;
        } );

        if ( isNaN( content ) ) {
          this.alerts.WARNING( 'File upload', `Invalid number(s) located in ${file.name}`, false );
        }

        if ( contentSetLength !== contentArr.length ) {
          this.alerts.INFO( 'File upload', `Duplicate number(s) located in ${file.name}. Content will be truncated with no duplicates.`, false );
        }

        // If the file being applied does not have any TFNs, do not allow it
        // to be applied as a TFN.
        if ( !tfn && this.state.allowedUploadTypes.includes( 'TFN' ) ) {
          const updatedAllowedUploadTypes = this.state.allowedUploadTypes.filter( ( allowedUploadType ) => {
            return allowedUploadType !== 'TFN';
          } );

          this.setState( {
            allowedUploadTypes: updatedAllowedUploadTypes
          } );
        }
      };
    };

    for ( let i = 0; i < files.length; ++i ) {
      verifyFiles( files[i] );
    }

    this.setState( {
      acceptedFiles: [files[0]]
    } );
  }

  /**
   * Removal of the files from the dropzone.
   *
   * @param {Event} event The click event to remove the file.
   * @param {String} filename The name of the file to remove.
   */
  onHandleClickRemoveFile( event, filename ) {
    const updatedFiles = this.state.acceptedFiles.filter( ( file ) => {
      return file.name !== filename;
    } );
    const updatedDescriptions = { ...this.state.descriptions };
    delete updatedDescriptions['description-' + filename];

    this.setState( {
      acceptedFiles: updatedFiles,
      descriptions: updatedDescriptions,
      allowedUploadTypes: this.props.filedata.ALLOWED_TYPES.split( ', ' )
    } );
  }

  /**
   * Handles the click event for applying a file to a DNIS. Only one file is
   * applied at a time (prevents the job from already running). However, this
   * does not stop 2 users applying a file to a DNIS at the same time...
   */
  onHandleClickApply( event ) {
    if ( this.state.acceptedFiles.length === 0 ) {
      return;
    }

    // Check for unfilled values. LEADGEN ON NET is allowed to choose a different DEFDNIS
    if ( this.state.uploadType === ''
      || ( this.props.filedata.DESTINATION === 'LEADGEN' && this.state.uploadType === 'ON NET' && this.state.DEFDNIS === '' ) ) {
      this.alerts.WARNING( 'File Upload', 'Please fill out all values in the apply section.', 8000 );

      return;
    }

    const file = [...this.state.acceptedFiles][0];

    this.uploadFilesToDNIS( file );
  }

  /**
   * Handles the deleting of the file from the DNIS. 'Yes' was selected and
   * will remove this file from the DNIS.
   */
  onHandleClickDelete( event ) {
    const fileUploadId = this.state.itemToRemove.FILE_UPLOAD_ID;

    this.setState( {
      deleteBody: 'Deleting. Please wait...'
    } );

    this.delete_from_dnis( fileUploadId ).then( ( results ) => {
      this.onHandleClose( null, true );
    } ).catch( ( exception ) => {
      this.onHandleException( exception );
    } );
  }

  /**
   * Delete icon was clicked to display the delete dialog.
   */
  onHandleOpenDeleteDialog( event ) {
    const itemToRemove = this.wijmoPanel2.control.selectedItems[0];

    this.setState( {
      showDeleteDialog: true,
      itemToRemove: itemToRemove
    } );
  }

  /**
   * Handles the closing of any dialogs.
   *
   * @param {Event} event Closing of any dialogs.
   */
  onHandleCloseDialogs( event ) {
    this.setState( {
      showLoadingApplyingDialog: false,
      showDeleteDialog: false
    } );
  }

  /**
   * Closes this dialog.
   */
  onHandleClose( event, refreshParent ) {
    clearInterval( this.progressInterval );

    this.setState( {
      contents: [{ NUMBER: 'Loading' }],
      details: [{ PROCESSED_ON: 'Loading' }],
      acceptedFiles: [],
      allowedUploadTypes: [],
      programTypes: [],
      defaultPrograms: [],
      descriptions: {},
      itemToRemove: {},
      actionStatus: {
        current: 0,
        total: 0
      },
      uploadType: '',
      programType: '',
      DEFDNIS: '',
      DEST_ID: '',
      applyingDialogBody: '',
      deleteBody: '',
      loading: true,
      showLoadingApplyingDialog: false,
      showDeleteDialog: false
    }, () => {
      this.props.onClose( event, refreshParent );
    } );
  }

  /****************************************************************************
   * RENDERS
   ***************************************************************************/

  renderDialogHeader() {
    const { filedata } = this.props;

    return (
      <DialogHeader
        caption={`${filedata.DEFDNIS} ${filedata.NAME}: Contents and Details of ${filedata.FILENAME}`}
        closeButton
        onClose={this.onHandleClose}
      />
    );
  }

  renderContents() {
    return (
      <div className='file-management-by-dnis-contents-container'>
        <div
          className='file-management-by-dnis-contents-grid-container'
          ref={this.wijmoGrid1}
          style={{ width: '100%' }}
        >
          <div className='file-management-by-dnis-contents-header'>Contents</div>
          <wj.FlexGrid
            className='file-management-by-dnis-contents-grid'
            ref={( panel ) => {
              this.wijmoPanel1 = panel; 
            }}
            selectionMode='Row'
            style={{ border: 'none' }}
            itemsSource={this.state.contents}
          >
            <wj.FlexGridColumn width='1.5*' header='NUMBER' binding='NUMBER' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='LENGTH' binding='LENGTH' isContentHtml={true} isReadOnly={true} align='center' />
          </wj.FlexGrid>
        </div>
      </div>
    );
  }

  renderDetails() {
    return (
      <div className='file-management-by-dnis-details-container'>
        <div
          className='file-management-by-dnis-details-grid-container'
          ref={this.wijmoGrid2}
          style={{ width: '100%' }}
        >
          <div className='file-management-by-dnis-details-header' title='p_api_file_upload_search'>{`Details of ${this.props.filedata.FILENAME}`}</div>
          <wj.FlexGrid
            className='file-management-by-dnis-details-grid'
            ref={( panel ) => {
              this.wijmoPanel2 = panel; 
            }}
            selectionMode='Row'
            style={{ border: 'none' }}
            itemFormatter={this.formatCell}
            itemsSource={this.state.details}
          >
            <wj.FlexGridColumn width='*' header='Destination' binding='DESTINATION' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='DNIS' binding='DEFDNIS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='2*' header='Name' binding='NAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Program Type' binding='PROGRAM_TYPE' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='PDNIS' binding='PDNIS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Program Name' binding='PROGRAM_NAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='.5*' header='Type' binding='TYPE' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='2*' header='Filename' binding='FILENAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='2*' header='Description' binding='DESCRIPTION' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='.5*' header='Dups' binding='COUNT_DUPS' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='.75*' header='Errors' binding='COUNT_ERROR' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Processed' binding='PROCESSED' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Processed On' binding='PROCESSED_ON' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='*' header='Username' binding='USER_NAME' isContentHtml={true} isReadOnly={true} align='center' />
            <wj.FlexGridColumn width='.75*' header='Delete' binding='__delete__button' isContentHtml={true} isReadOnly={true} align='center' />
          </wj.FlexGrid>
        </div>
      </div>
    );
  }

  renderUploadFileToDNIS() {
    const { filedata } = this.props;

    const descriptions = this.state.acceptedFiles.map( ( file ) => {
      return (
        <div className='file-management-footer-description-item' key={'div-' + file.name}>
          <label className='file-management-footer-description-item-label'>{file.name}</label>
          <input className='file-management-footer-description-item-input' name={'description-' + file.name} onChange={this.onHandleChange} />
        </div>
      );
    } );

    const uploadOptions = this.state.allowedUploadTypes.map( ( uploadType ) => {
      return (
        <option key={uploadType} value={uploadType}>{uploadType}</option>
      );
    } );

    const programTypes = this.state.programTypes.map( ( programType ) => {
      return <option key={programType.ROUTING_TYPE_ID} value={programType.ROUTING_TYPE_ID}>{programType.ROUTING_TYPE_NAME}</option>;
    } );

    const defaultPrograms = this.state.defaultPrograms.map( ( defaultProgram ) => {
      return <option key={defaultProgram.PDNIS} value={defaultProgram.PDNIS}>{defaultProgram.PDNIS_TEXT}</option>;
    } );

    return (
      <div className='file-management-by-dnis-upload-container'>
        <div className='file-management-by-dnis-upload-grid-container'>
          <span className='file-management-by-dnis-upload-grid-header'>Upload a New File to {filedata.DEFDNIS} - {filedata.NAME}</span>
          <span className='file-management-by-dnis-dropzone-container'>
            <span className='file-management-footer-dropzone-grid'>
              <span className='file-management-footer-grid-header'>File Upload</span>
              <UploadDropZone acceptedFiles={this.state.acceptedFiles} onAddFile={this.onHandleAddFile} onClickRemove={this.onHandleClickRemoveFile} />
              <span className='file-management-footer-grid-footer'>Files to upload - {this.state.acceptedFiles.length}</span>
            </span>
          </span>
          <span className='file-management-by-dnis-description-container'>
            <span className='file-management-by-dnis-description-grid'>
              <span className='file-management-footer-grid-header'>Descriptions</span>
              <span className='file-management-footer-description-item-container'>{descriptions}</span>
            </span>
          </span>
          <span className='file-management-by-dnis-apply-container'>
            <span className='file-management-footer-description-grid'>
              <span className='file-management-footer-grid-header'>Apply</span>
              <span className='file-management-apply-to-dnis-body' style={{ overflow: 'auto', border: 'solid 1px #c8c8c8', gridRow: '2 / 4' }}>
                <span className='file-management-apply-to-dnis-values'>
                  <span className='file-management-apply-to-dnis-value'>
                    <label className='file-management-apply-to-dnis-label'>Destination:</label>
                    <select className='file-management-footer-actions-select' disabled>
                      <option value={filedata.DESTINATION}>{filedata.DESTINATION}</option>
                    </select>
                  </span>
                  <span className='file-management-apply-to-dnis-value'>
                    <label className='file-management-apply-to-dnis-label'>Name:</label>
                    <select className='file-management-footer-actions-select' disabled>
                      <option value={filedata.DEST_ID}>{filedata.DEFDNIS} - {filedata.NAME}</option>
                    </select>
                  </span>
                  <span className='file-management-apply-to-dnis-value'>
                    <label className='file-management-apply-to-dnis-label'>Upload Type:</label>
                    <select className='file-management-apply-to-dnis-input' name='uploadType' onChange={this.onHandleChange}>
                      <option value=''></option>
                      {uploadOptions}
                    </select>
                  </span>
                  <span className='file-management-apply-to-dnis-value' hidden={!( filedata.DESTINATION === 'LEADGEN' && this.state.uploadType === 'ON NET' )}>
                    <label className='file-management-apply-to-dnis-label'>Program Type:</label>
                    <select className='file-management-apply-to-dnis-input' name='programType' onChange={this.onHandleChange} value={this.state.programType}>
                      <option value=''></option>
                      {programTypes}
                    </select>
                  </span>
                  <span className='file-management-apply-to-dnis-value' hidden={!( filedata.DESTINATION === 'LEADGEN' && this.state.uploadType === 'ON NET' )}>
                    <label className='file-management-apply-to-dnis-label'>Default DNIS:</label>
                    <select className='file-management-apply-to-dnis-input' name='DEFDNIS' onChange={this.onHandleChange} value={this.state.DEFDNIS}>
                      <option value=''></option>
                      {defaultPrograms}
                    </select>
                  </span>
                </span>
              </span>
            </span>
          </span>
        </div>
      </div>
    );
  }

  renderDialogBody() {
    return (
      <DialogBody>
        <div className='file-management-by-dnis-dialog-main-container'>
          {this.renderContents()}
          {this.renderDetails()}
          {this.renderUploadFileToDNIS()}
        </div>
      </DialogBody>
    );
  }

  renderDialogFooter() {
    return (
      <DialogFooter>
        <button style={{ 'width': '120px' }} className='file-management-buttons' onClick={this.onHandleClickApply}>Apply</button>
        <button style={{ 'width': '120px', 'backgroundColor': '#b6b6b6', 'border': '1pt solid #b6b6b6' }} className='file-management-buttons' onClick={this.onHandleClose}>Close</button>
      </DialogFooter>
    );
  }

  render() {
    if ( this.props.show ) {
      const { filedata } = this.props;
      const itemToRemove = this.state.itemToRemove;
      const showOverlay = this.state.showLoadingApplyingDialog
        || this.state.showDeleteDialog;

      return (
        <Dialog show={this.props.show} width={90} height={90} onClose={this.props.onClose}>
          {this.renderDialogHeader()}
          {this.renderDialogBody()}
          {this.renderDialogFooter()}
          <Overlay show={showOverlay} />
          <LoadingDialog
            show={this.state.showLoadingApplyingDialog}
            onClose={this.onHandleCloseDialogs}
            body={
              this.state.applyingDialogBody
                ? this.state.applyingDialogBody
                : `Inserting batch ${this.state.actionStatus.current} of ${this.state.actionStatus.total}`
            }
          />
          <DeleteDialog
            caption={'Remove File from DNIS'}
            body={this.state.deleteBody === ''
              ? `Remove ${filedata.FILENAME} from ${itemToRemove.DEFDNIS} - ${itemToRemove.NAME}?`
              : this.state.deleteBody}
            show={this.state.showDeleteDialog}
            onClose={this.onHandleCloseDialogs}
            onDelete={this.onHandleClickDelete}
          />
        </Dialog>
      );
    }

    return null;
  }
}

export default withRouter(
  connect(
    ( store ) => {
      return {
        auth: store.auth.auth,
        bugsnag: store.bugsnag.Bugsnag,
        user: store.user.user
      };
    }
  )( FileDetailsByDNISDialog )
);



// WEBPACK FOOTER //
// ./src/content/enterprise/filemanagement/components/FileDetailsByDNISDialog.js